import { useState, useEffect } from 'react';
import { Box, Grid, Container, Typography, colors, Button, CircularProgress } from '@mui/material';
import Page from '../components/Page';
import { Card, ListCard, TotalBusinesses } from '../sections/@dashboard/app';
import { api } from 'src/Api';
import Chart from 'react-apexcharts';
import Iconify from 'src/components/Iconify';
import { useNavigate } from 'react-router-dom';

export default function DashboardApp() {
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('user'));
  const [loading, setloading] = useState(true);
  const [barCategories, setBarCategories] = useState([]);
  const [barData, setBarData] = useState([]);
  const [shipmentList, setShipmentList] = useState([]);
  const [totalShipment, setTotalShipments] = useState('');
  const [totalTrucks, setTotalTrucks] = useState('');
  const [totalGroups, setTotalGroups] = useState('');

  useEffect(() => {
    getDashboard();
  }, []);

  useEffect(() => {
    getUser_by_id();
  }, [userData]);

  function getUser_by_id() {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.get_user_by_id, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          localStorage.setItem('user', JSON.stringify(result.data));
        } else {
          console.error('Request failed with status:', result.status);
        }
      })
      .catch((error) => {
        console.log('error', error);
      });
  }
  function getDashboard() {
    setloading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.dashboard, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setBarCategories(result.data?.monthwise_shipment?.month);
          setBarData(result.data?.monthwise_shipment?.count);
          setShipmentList(result.data?.top_shipments);
          setTotalShipments(result.data?.total_shipments);
          setTotalTrucks(result.data?.total_trucks);
          setTotalGroups(result.data?.total_groups);
          setloading(false);
        } else {
          setloading(false);
          setBarCategories([]);
          setBarData([]);
          setShipmentList([]);
          setTotalShipments('');
          setTotalTrucks('');
          setTotalGroups('');
        }
      })
      .catch((error) => {
        setloading(false);
        console.log('error', error);
      });
  }

  const barOptions = {
    chart: {
      id: 'learner-progress',
      type: 'bar',
      toolbar: {
        show: false
      }
    },
    colors: [process.env.REACT_APP_PRIMARY],
    xaxis: {
      categories: barCategories
    },
    plotOptions: {
      bar: {
        distributed: false
      }
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        type: 'vertical', // Can be 'horizontal' or 'vertical'
        shadeIntensity: 0.5,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 0.7,
        stops: [40, 100] // Stops for gradient transition points
      }
    },
    dataLabels: {
      enabled: true, // Show the data labels
      style: {
        colors: ['#ffffff'] // Set label color to black
      }
    }
  };

  const barSeries = [
    {
      name: 'Progress',
      data: barData // Array of numbers
    }
  ];

  return (
    <Page title={`Dashboard | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container maxWidth="xl">
        <Grid container spacing={2}>
          <Typography p={2} variant="h4">
            Dashboard
          </Typography>

          {loading ? (
            <Grid
              container
              px={4}
              xs={12}
              sm={12}
              md={12}
              sx={{ display: 'flex', justifyContent: 'center', alignItem: 'center', marginTop: 3 }}
            >
              <CircularProgress />
            </Grid>
          ) : (
            <>
              <Grid
                container
                spacing={2}
                px={2}
                sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Card
                    // disabled={
                    //   userData?.role?.role_name === 'Truck Driver' ||
                    //   userData?.role?.role_name === 'Shipper' ||
                    //   userData?.role?.role_name === 'Carrier'
                    // }
                    onClick={() => navigate('/dashboard/search_loads')}
                    boxStyle={{
                      background:
                        'linear-gradient(135deg, rgba(255, 215, 0, 0.4), rgba(255, 215, 0, 0))',
                      border: '1px solid rgba(255, 215, 0, 0.4)'
                    }}
                    count={totalShipment}
                    title={'Total Posted Shipments'}
                    icons={'ph:shipping-container-duotone'}
                    iconStyle={{ fontSize: 50, color: '#E58D00' }}
                    mainCardStyle={{
                      boxShadow: '0px 4px 6px rgba(255, 215, 0, 0.4)',
                      border: '2px solid rgba(255, 215, 0, 0.4)'
                    }}
                    countStyle={{ color: '#E58D00' }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Card
                    onClick={() => navigate('/dashboard/search_trucks')}
                    boxStyle={{
                      background:
                        'linear-gradient(135deg, rgba(56, 136, 85, 0.4), rgba(255, 215, 0, 0))',
                      border: '1px solid rgba(56, 136, 85, 0.4)'
                    }}
                    count={totalTrucks}
                    title={'Total Posted Trucks'}
                    icons={'ph:truck-duotone'}
                    iconStyle={{ fontSize: 50, color: '#388855' }}
                    mainCardStyle={{
                      boxShadow: '0px 4px 6px rgba(56, 136, 85, 0.4)',
                      border: '2px solid rgba(56, 136, 85, 0.4)'
                    }}
                    countStyle={{ color: '#388855' }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Card
                    // disabled={
                    //   userData?.role?.role_name === 'Admin' ||
                    //   userData?.role?.role_name === 'Truck Driver' ||
                    //   userData?.role?.role_name === 'Carrier'
                    // }
                    onClick={() => {
                      // if (userData?.role?.role_name.tolowercase() === 'admin') {
                      //   {
                      //   }
                      // } else {
                      navigate('/dashboard/private_network');
                      // }
                    }}
                    boxStyle={{
                      background:
                        'linear-gradient(135deg, rgba(113, 81, 165, 0.4), rgba(255, 215, 0, 0))',
                      border: '1px solid rgba(113, 81, 165, 0.4)'
                    }}
                    count={totalGroups}
                    title={'Total Groups'}
                    icons={'material-symbols:groups-2-outline-rounded'}
                    iconStyle={{ fontSize: 50, color: '#7151A5' }}
                    mainCardStyle={{
                      boxShadow: '0px 4px 6px rgba(113, 81, 165, 0.4)',
                      border: '2px solid rgba(113, 81, 165, 0.4)'
                    }}
                    countStyle={{ color: '#7151A5' }}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                pt={1}
                px={2}
                xs={12}
                sm={12}
                md={12}
                sx={{
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start'
                }}
              >
                {/* Chart Section */}
                <Grid
                  item
                  xs={shipmentList.length > 0 ? 7.9 : 12}
                  sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                >
                  <Typography
                    style={{
                      fontSize: 20,
                      color: '#010f58',
                      fontWeight: 'bold',
                      marginBottom: 10,
                      textAlign: 'center'
                    }}
                  >
                    Month Wise Shipments
                  </Typography>
                  <div style={{ height: '300px', width: '100%' }}>
                    {' '}
                    {/* Set a fixed height for the chart */}
                    <Chart options={barOptions} series={barSeries} type="bar" height="100%" />
                  </div>
                </Grid>

                {/* List Section */}
                {shipmentList.length > 0 && (
                  <Grid
                    item
                    xs={12}
                    md={3.8}
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: 1,
                      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '350px',
                        width: '100%'
                      }}
                    >
                      <div style={{}}>
                        {/* Map through the shipmentList and render ListCards */}
                        {shipmentList.map((val, index) => (
                          <ListCard
                            key={index}
                            origin={val.location_origin}
                            destination={val.location_destination}
                            equipmentType={val.equipment_type}
                            weight={`${val.weight_lbs} lbs`}
                            length={`${val.length_ft} ft`}
                          />
                        ))}
                      </div>

                      {/* View More Button */}
                      {shipmentList.length >= 5 && (
                        <Box
                          style={{
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'flex-end',
                            marginBottom: 8
                          }}
                        >
                          <Button
                            variant="contained"
                            sx={{ height: 30, fontSize: 10, letterSpacing: 0.4 }}
                            onClick={() => navigate('/dashboard/my_shipments')}
                          >
                            View More
                          </Button>
                        </Box>
                      )}
                    </div>
                  </Grid>
                )}
              </Grid>
            </>
          )}
        </Grid>
      </Container>
    </Page>
  );
}
